import React, { useEffect } from "react";

// Lightweight per-page SEO / Open Graph tag manager (no extra deps).
export function useSeo({ title, description, image, path }) {
  useEffect(() => {
    const base = "Project Management Network";
    document.title = title ? `${title} — ${base}` : base;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title ? `${title} — ${base}` : base);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title ? `${title} — ${base}` : base);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://pmnetwork.org${path || ""}`);
  }, [title, description, image, path]);
}
